@if($isAuthenticated | async) {
<div class="antialiased h-full">
	<div *ngIf="isFirstSetup; else mainlayout">
		<app-header></app-header>
		<main class="h-full pt-16 relative">
			<app-setup></app-setup>
		</main>
	</div>

	<ng-template #mainlayout>
		<app-header></app-header>
		<app-sidebar [isCollapsed]="($isSidebarCollapsed | async) ?? false" (sidebarToggle)="onSidebarToggle()"></app-sidebar>
		<main
			class="pl-8 pr-4 h-full pt-16 relative duration-300"
			[ngClass]="{
				'ml-64': !($isSidebarCollapsed | async),
				'ml-20': ($isSidebarCollapsed | async)
			}">
			<div class="flex flex-col mb-4" *ngIf="errors.length > 0">
				<p-button
					severity="danger"
					variant="outlined"
					class="mb-4 ml-auto"
					*ngIf="errorsArray(errors).length > 1"
					(onClick)="clearErrors()">
					<fa-icon [icon]="['fas', 'close']"></fa-icon>
					<span>Delete All</span>
				</p-button>
				@for(error of errors; track error) {
				<p-message [severity]="error.severity" (onClose)="removeError(error.key)" [closable]="true" class="mb-2">
					{{ error.content }}
				</p-message>
				}
			</div>

			<xng-breadcrumb [separator]="iconTemplate"> </xng-breadcrumb>
			<ng-template #iconTemplate>
				<fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
			</ng-template>
			<router-outlet></router-outlet>
		</main>
		<p-dialog
			header="Header"
			[(visible)]="versionService.isNewVersionAvailable"
			[modal]="true"
			[style]="{ width: '50vw' }"
			[draggable]="false"
			[resizable]="false">
			<ng-template pTemplate="header">
				<span class="">New Version Available</span>
			</ng-template>
			<p class="py-4">Version {{ versionService.version }} available. Reload page to get new features!</p>
			<p class="py-4 text-xs">{{ versionService.buildDate }}</p>
			<ng-template pTemplate="footer">
				<p-button (onClick)="versionService.applyUpdate()">
					<span>Reload</span>
				</p-button>
			</ng-template>
		</p-dialog>
	</ng-template>
</div>
}
